import { useRef } from "react";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import NotMarkedNew from "Assets/Icons/NotMarkedIconNew";
import NotMarkedMB from "Assets/Icons/NotMarkedMB";
import NotMarkedMBWhite from "Assets/Icons/NotMarkedMBWhite";
import NotMarkedNewWhite from "Assets/Icons/NotMarkedNewWhite";
import RightArrowWhiteIcon from "Assets/Icons/RightArrowWhiteIcon";
import TickIcon from "Assets/Icons/TickIcon";
import TickIconMB from "Assets/Icons/TickIconMB";
import TickIconWhite from "Assets/Icons/TickIconWhite";
import TickIconWhiteMB from "Assets/Icons/TickIconWhiteMB";
export interface ChapterListingComponentIF {
  data: any[];
  selectedChapter: any;
  onSelectHandler: any;
}
const ListingDiv = styled<any>("div")`
  display: flex;
  justify-content: space-between;
  padding: 16px 12px;
  cursor: pointer;
  background: ${({ isSelected }: any) => (isSelected ? "#008DC4" : "#fff")};
  color: ${({ isSelected }: any) => (isSelected ? "#fff" : "#333")};
`;
const StyledSpan = styled<any>("span")`
  font-size: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "12px" : ""};
  font-weight: 700;
  margin-top: 2px;
`;
const ChapterListingComponent = ({
  data,
  selectedChapter,
  onSelectHandler,
}: any) => {
  console.log("selectedChapterselectedChapter", data, selectedChapter);
  const { screen }: any = useWindowSize();
  const selectedListingRef: any = useRef(null);
  return (
    <>
      {data.map((ele: any, index: number) => {
        return (
          <ListingDiv
            ref={ele.key === selectedChapter?.key ? selectedListingRef : null}
            key={index}
            isSelected={selectedChapter?.key == ele.key}
            onClick={() => {
              onSelectHandler(ele);
            }}
          >
            <div className="d-flex align-items-center">
              <StyledSpan screen={screen}>
                {ele.name}&nbsp;
                {index + 1}
              </StyledSpan>
              {selectedChapter?.key != ele.key ? (
                <span
                  className={
                    ["xs", "sm", "md"].includes(screen) ? "pl-1" : "pl-2"
                  }
                >
                  {ele.isComplete == 3 ? (
                    <>
                      {["xxl", "xl", "lg"].includes(screen) ? (
                        <TickIcon />
                      ) : (
                        <TickIconMB></TickIconMB>
                      )}
                    </>
                  ) : ele.isComplete == 2 ? (
                    <>
                      {["xxl", "xl", "lg"].includes(screen) ? (
                        <NotMarkedNew></NotMarkedNew>
                      ) : (
                        <NotMarkedMB></NotMarkedMB>
                      )}
                    </>
                  ) : null}
                </span>
              ) : (
                <span
                  className={
                    ["xs", "sm", "md"].includes(screen) ? "pl-1" : "pl-2"
                  }
                >
                  {ele.isComplete == 3 ? (
                    <>
                      {["xxl", "xl", "lg"].includes(screen) ? (
                        <TickIconWhite />
                      ) : (
                        <TickIconWhiteMB></TickIconWhiteMB>
                      )}
                    </>
                  ) : ele.isComplete == 2 ? (
                    <>
                      {["xxl", "xl", "lg"].includes(screen) ? (
                        <NotMarkedNewWhite></NotMarkedNewWhite>
                      ) : (
                        <NotMarkedMBWhite></NotMarkedMBWhite>
                      )}
                    </>
                  ) : null}
                </span>
              )}
            </div>
            <div className="d-flex align-items-center">
              {ele.key != selectedChapter?.key ? (
                <></>
              ) : (
                <RightArrowWhiteIcon></RightArrowWhiteIcon>
              )}
            </div>
          </ListingDiv>
        );
      })}
    </>
  );
};
export default ChapterListingComponent;
